import React from 'react'
import { LucideIcon, AlertTriangle } from 'lucide-react'

interface RevFinOpsMetricCardProps {
  title: string
  value: string | number
  icon: LucideIcon
  trend?: { value: number; direction: 'up' | 'down' }
  loading?: boolean
  error?: string
  onRetry?: () => void
}

export function RevFinOpsMetricCard({
  title,
  value,
  icon: Icon,
  trend,
  loading,
  error,
  onRetry
}: RevFinOpsMetricCardProps) {
  if (loading) {
    return (
      <div className="metric-card">
        <div className="loading-pulse h-8 w-8 mx-auto mb-3 rounded-monumenta bg-brand-dark-light"></div>
        <div className="loading-pulse h-8 w-24 mx-auto mb-2 rounded bg-brand-dark-light"></div>
        <div className="loading-pulse h-4 w-32 mx-auto rounded bg-brand-dark-light"></div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="metric-card border border-brand-red/30">
        <AlertTriangle className="h-8 w-8 text-brand-red mx-auto mb-2" />
        <p className="text-sm text-brand-red mb-2 px-2">{error}</p>
        {onRetry && (
          <button
            onClick={onRetry}
            className="btn-ghost text-xs px-3 py-1"
          >
            Tentar Novamente
          </button>
        )}
      </div>
    )
  }

  return (
    <div className="metric-card group">
      <Icon className="h-8 w-8 text-brand-primary mx-auto mb-3 transition-transform group-hover:scale-110" />
      <div className="metric-value">{value}</div>
      <div className="metric-label">{title}</div>
      {trend && (
        <div className={`metric-trend ${trend.direction}`}>
          {trend.direction === 'up' ? '↑' : '↓'} {trend.value}%
        </div>
      )}
    </div>
  )
}
